export default "__VITE_ASSET__ahHM4WbZ__"